import * as React from 'react';
import { useParams } from 'react-router-dom';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { WorkPlaceAssessmentPageView } from '../features/activities/WorkPlaceAssessmentPageView';

export default function WorkplaceAssessmentPage(): JSX.Element {
    
    const params = useParams<{ activityId: string }>();
    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="workplaceassessment">
            {params.activityId 
                ? <WorkPlaceAssessmentPageView activityId={params.activityId} />
                : <span>ugyldig url</span>
        }
        </ProtectedPageWrapper>
    );
}
